import { render } from "./ResetIcon.vue?vue&type=template&id=a84dd132&scoped=true"
import script from "./ResetIcon.vue?vue&type=script&lang=js"
export * from "./ResetIcon.vue?vue&type=script&lang=js"

import "./ResetIcon.vue?vue&type=style&index=0&id=a84dd132&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84dd132"]])

export default __exports__